module.exports = __webpack_public_path__ + "img/Group 28051@2x.46341437.png";